import React, { useState ,useEffect,useRef} from 'react'
import './header.css'
import menu from '../../Assets/menu-alt-1_svgrepo.com.svg'
import profileimg from '../../Assets/User_2.svg'
import ProfileCard from '../ProfileCard/ProfileCard'

const Header = (props) => {
  const role=JSON.parse(localStorage.getItem("userData")).Roles;  
  const [profile,setprofile]=useState(false)
  const open=()=>{
    if(profile){
    setprofile(false);
    }
    else
    {
    setprofile(true);
    }
  }
  const closeProfile=()=>{
    setprofile(false)
  }
  const divRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)&&!event.target.classList.contains('profile-img')) {
        // Clicked outside the div, so close it
        setprofile(false);
       
      }
    }
      // Attach the event listener to the document body
      document.addEventListener("mousedown", handleClickOutside);

      // Clean up the event listener when the component unmounts
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
  },[]);
  return (
    <div className={role=="Admin"?'container-fluid header-div':" container-fluid header-div2"}>
        <div className='row m-2 mt-3 justify-content-evenly'>
            {role=="Admin"?<div className='col-1 open-close'><img src={menu} style={{cursor:"pointer"}} alt="" onClick={props.openClose}/></div>:""}
            <div className={`col ${role=="admin"?"ps-5":""} ps-md-0 align-items-center`}><h2>{props.headtop}</h2></div>
            <div className='col-1 text-end me-4 me-md-0'> <img src={profileimg} alt=""   className="profile-img rounded-pill" onClick={()=>{open()}} style={{width:"40px"}}/></div>
        </div>
            <div  ref={divRef}>
              {profile?<ProfileCard close={closeProfile}/>:""}
            </div>
    </div>
  )
}

export default Header